import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import Layout from "../../components/layout/layout";
import PromocodeTable from "../../components/tables/promocodeTable";
import CustomSelect from "../../components/utils/CustomSelect";

function PromoCodePage() {
  return (
    <Layout id="promoCode">
      <div className="top-bar">
        <h2>Codes Promo</h2>
        <div className="pagination">
          <Link to="/" className="link">Accueil</Link>
          <IoIosArrowForward color="#A7A7A7" />
          <Link to="#" className="link">Codes Promo</Link>
        </div>
      </div>

      <div className="filter-bar">
        <button className="nouveau">
            <span className="plus">+</span>
            <span className="text">Nouveau</span>
        </button>
        <div className="recherche">
          <input type="text" placeholder="Rechercher"/>
          <CustomSelect 
            options={[
              {value: 0, label: "Type"},
              {value: 1, label: "1"},
              {value: 2, label: "2"}
            ]}
          />
        </div>
      </div>

      <PromocodeTable />
    </Layout>
  );
}

export default PromoCodePage;
